interface IconProps {
  color?: string
  width?: number
  height?: number
}
export default function WalletTabIcon({ color = 'white', width = 35, height = 35 }: IconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 37 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.675668 6.68272L32.9413 0.841309L32.9415 5.57603H14.0033V6.68272H37V31.5088H0.491009V24.5722H6.91144L9.10198 26.7628H13.6803C13.8424 27.3926 14.4142 27.858 15.0946 27.858C15.9012 27.858 16.555 27.2042 16.555 26.3977C16.555 25.5911 15.9012 24.9373 15.0946 24.9373C14.4142 24.9373 13.8424 25.4027 13.6803 26.0326H9.40444L7.21389 23.8421H0.491009V20.1912H13.6803C13.8424 20.821 14.4142 21.2864 15.0946 21.2864C15.9012 21.2864 16.555 20.6326 16.555 19.8261C16.555 19.0195 15.9012 18.3657 15.0946 18.3657C14.4142 18.3657 13.8424 18.8311 13.6803 19.461H0.491009V16.5403H7.21389L9.40444 14.3497H13.6803C13.8424 14.9796 14.4142 15.445 15.0946 15.445C15.9012 15.445 16.555 14.7912 16.555 13.9846C16.555 13.1781 15.9012 12.5243 15.0946 12.5243C14.4142 12.5243 13.8424 12.9897 13.6803 13.6195H9.10198L6.91144 15.8101H0.491009V6.72624L0.476074 6.71886L0.491009 6.71615V6.68272H0.675668ZM30.251 21.8086C31.7452 21.8086 32.9564 20.5973 32.9564 19.1031C32.9564 17.6089 31.7452 16.3976 30.251 16.3976C28.7568 16.3976 27.5455 17.6089 27.5455 19.1031C27.5455 20.5973 28.7568 21.8086 30.251 21.8086Z"
        fill={color}
      />
    </svg>
  )
}
